import type { Vertex, Edge } from '@shared/hydraulic'
import { lengthToMeters } from '@shared/hydraulic'

export function getVertexElevation(vertex: Vertex): number {
  // #850: one length table for the repo. The local switch handled only ft and
  // in and read mm/cm/km as metres; `lengthToMeters` converts all of them and
  // throws on a unit nobody has taught it, the same way the solver does when
  // it reads these elevations (compressible/bridge.ts). A missing unit still
  // means metres — that is a shape the schema allows, not an unknown unit.
  const toMeters = (val: number, unit: string | undefined): number =>
    lengthToMeters(val, unit ?? 'm')

  switch (vertex.type) {
    case 'junction':
    case 'flow_demand':
    case 'pressure_boundary':
    case 'control_valve':
    case 'compressor':
    case 'fan':
    case 'blower':
    case 'pressure_relief_valve':
    case 'three_way_valve':
    case 'balancing_orifice':
    case 'orifice_meter':
    case 'venturi_meter':
    case 'nozzle_meter':
    case 'reducer':
    case 'tank': {
      const e = (vertex as { elevation?: { value: number; unit?: string } }).elevation
      return e !== undefined ? toMeters(e.value, e.unit) : 0
    }
    case 'centrifugal_pump': {
      const e = (vertex as { suction_elevation?: { value: number; unit?: string } }).suction_elevation
      return e !== undefined ? toMeters(e.value, e.unit) : 0
    }
    case 'heat_exchanger':
    case 'curve_loss':
    case 'fixed_loss':
    case 'pressure_gain':
    case 'heat_source_sink': {
      const e = (vertex as { inlet_elevation?: { value: number; unit?: string } }).inlet_elevation
      return e !== undefined ? toMeters(e.value, e.unit) : 0
    }
    default:
      return 0
  }
}

export function getConnectedEdges(vertexId: string, edges: Edge[]): Edge[] {
  return edges.filter(
    e => e.connection.source_id === vertexId || e.connection.target_id === vertexId
  )
}
